import { SearchResultComponent } from './search-result/search-result.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ProductListComponent } from './product-list/product-list.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { AccessoryCatComponent } from './accessory-cat/accessory-cat.component';
import { AccessoryListComponent } from './accessory-list/accessory-list.component';
import { AccessoryDetailComponent } from './accessory-detail/accessory-detail.component';

const routes: Routes = [
    {
        path: '',
        component: HomeComponent
    },
    { path: 'home', redirectTo: '' },
    { path: 'product/details/:url', component: ProductDetailComponent },
    { path: 'search/:keyword', component: SearchResultComponent },
    { path: 'contact-us', component: ContactUsComponent },
    { path: 'product/list/:type/:brand', component: ProductListComponent },
    { path: 'accessories', component: AccessoryCatComponent },
    { path: 'accessories/list/:getBy/:value', component: AccessoryListComponent },
    { path: 'accessories/details/:url', component: AccessoryDetailComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TemplatesRoutingModule {}
